import map from 'lodash/map'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import { StatusEnum, UnitOfMeasureCategoryEnum } from '@ztechapps/common.contract'

const statusValues = map(StatusEnum, (e) => e)
const categoryValues = map(UnitOfMeasureCategoryEnum, (e) => e)

export const unitOfMeasureListFieldConfig: ListFieldConfig = {
  code: {
    name: 'code',
    displayName: 'Code',
    defaultOnSearch: true,
    size: 170,
    index: 0,
  },
  name: {
    name: 'name',
    displayName: 'Name',
    size: 250,
    index: 1,
  },
  symbol: {
    name: 'symbol',
    displayName: 'Symbol',
    size: 130,
    index: 2,
  },
  category: {
    name: 'category',
    displayName: 'Category',
    type: ListFieldTypeEnum.select,
    fieldSettings: { listValues: categoryValues },
    size: 170,
    index: 3,
  },
  conversionFactor: {
    name: 'conversionFactor',
    displayName: 'Conversion Factor',
    type: ListFieldTypeEnum.number,
    size: 200,
    index: 4,
    excludeOnSearch: true,
  },
  status: {
    name: 'status',
    displayName: 'Status',
    type: ListFieldTypeEnum.select,
    fieldSettings: { listValues: statusValues },
    size: 150,
    index: 5,
    excludeOnSearch: true,
  },
  updatedAt: {
    name: 'updatedAt',
    displayName: 'Updated',
    type: ListFieldTypeEnum.dateTimeZone,
    size: 200,
    index: 6,
    excludeOnSearch: true,
  },
}
